$(function () {
    var supportsIntersectionObserver = ('IntersectionObserver' in window);

    $('.karusell').on('init', function () {
        var slides = $('.slick-slide.slick-active').length;
        if (slides > 1 && (slides % 2 === 0)) {
            $('.slick-track').animate({
                left: -234
            }, 0);
        }
    });

    uppdateraMenyVidScroll();
    visaAktivtMalVidScroll();
    visaNyckeltalVidScroll();
    stickyMeny();
    spelaPausaToppVideo();
    slick();
    visaPopoverAvkastning();
    logotypScrollTillTopp();

    function slick() {
        $('.karusell').find('.modal').each(function () {
            $(this).appendTo('#innehall');
        });

        $('.karusell').slick(
            {
                dots: true,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                variableWidth: false,
                centerMode: true,
                centerPadding: '0',
                mobileFirst: true,
                arrows: false,
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Nästa">Nästa</button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Förra">Förra</button>',
                infinite: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            variableWidth: true,
                            arrows: true
                        }
                    }
                ]
            });
    }

    function uppdateraMenyVidScroll() {
        var sections = $('.vagn');
        var options = {
            rootMargin: '-20% 0% -40% 0%'
        };

        if (!supportsIntersectionObserver) {
            return;
        }

        /* eslint-disable */
        var observer = new IntersectionObserver(function (entries, observer) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    intersectionHandler(entries[i]);
                }
            }
        }, options);
        /* eslint-enable */

        for (var i = 0; i < sections.length; i++) {
            observer.observe(sections[i]);
        }

        function intersectionHandler(entry) {
            var activeLinks = $('#navbar-sticky a.selected');
            var current = $('#navbar-sticky a[href="#' + entry.target.id + '"]');

            if (current.length && !current.hasClass('selected')) {
                activeLinks.removeClass('selected');
                current.addClass('selected');
            }
        }
    }

    function visaAktivtMalVidScroll() {
        var sections = $('.mal-yta');
        var options = {
            rootMargin: '-45% 0% -55% 0%'
        };

        if (!supportsIntersectionObserver) {
            return;
        }

        initAnimations(sections);

        /* eslint-disable */
        var observer = new IntersectionObserver(function (entries, observer) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    intersectionHandler(entries[i]);
                }
            }
        }, options);
        /* eslint-enable */

        for (var i = 0; i < sections.length; i++) {
            observer.observe(sections[i]);
        }

        function intersectionHandler(entry) {
            var section = $('#' + entry.target.id);

            if (section.length && !section.hasClass('active')) {
                sections.removeClass('active');
                section.addClass('active');

                animateGraph(section);
                animateBelopp(section);
                animateKundnojdhet(section);
                animateDriftkostnad(section);
                animateMangfald(section);
            }
        }
    }

    function visaNyckeltalVidScroll() {
        var nyckeltal = document.getElementById('nyckeltal');
        var options = {
            rootMargin: '-20% 0% -20% 0%'
        };

        if (!supportsIntersectionObserver) {
            return;
        }

        initBelopp($('#nyckeltal'));

        /* eslint-disable */
        var observer = new IntersectionObserver(function (entries, observer) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    intersectionHandler(entries[i]);
                }
            }
        }, options);
        /* eslint-enable */

        observer.observe(nyckeltal);

        function intersectionHandler(entry) {
            var section = $('#' + entry.target.id);
            if (section.length && !section.hasClass('active')) {
                animateBelopp(section);
            }
        }
    }

    function stickyMeny() {
        var navbar = document.getElementById('navbar-sticky');
        var innehall = document.getElementById('innehall');
        var sticky = navbar.offsetTop;

        function makeSticky() {
            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
                innehall.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
                innehall.classList.remove('sticky');
            }
        }

        window.onscroll = function () {
            makeSticky();
        };
    }

    function spelaPausaToppVideo() {
        $('#toppVideo').on('click', function (e) {
            var video = e.target;
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });
    }

    function visaPopoverAvkastning() {
        var visibleClass = 'synlig';
        $('.avkastning-kommentar a').on('click', function () {
            $('.avkastning .graf-popover').each(function () {
                if ($(this).hasClass(visibleClass)) {
                    $(this).removeClass(visibleClass);
                } else {
                    $(this).addClass(visibleClass);
                }
            });
        });
    }

    function logotypScrollTillTopp() {
        $('.logotyp').on('click', function () {
            $('Html, body').animate({
                scrollTop: 0
            }, 1000, function () {
                $('#navbar-sticky a.selected').removeClass('selected');
                window.location.hash = '';
            });
            return false;
        });
    }

    function initAnimations(sections) {
        sections.each(function () {
            var section = $(this);
            initGraph(section);
            initBelopp(section);
            initDriftkostnad(section);
            initKundnojdhet(section);
            initMangfald(section);
        });
    }

    function initGraph(section) {
        var graph = section.find('.graf-stapel');
        if (graph.length) {
            graph.addClass('should-animate');
        }
    }

    function initBelopp(section) {
        var numbers = section.find('.belopp');
        if (numbers.length) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                if (start) {
                    belopp.text(start.toLocaleString());
                }
            });
        }
    }

    function initDriftkostnad(section) {
        var graph = section.find('.graf-driftkostnad');
        if (graph.length) {
            graph.addClass('should-animate');
        }
    }

    function initKundnojdhet(section) {
        var graph = section.find('.graf-kundnojdhet');
        var numbers = graph.find('.markor');
        if (graph.length) {
            graph.addClass('should-animate');
        }
        if (numbers.length) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                if (start) {
                    belopp.text(start.toLocaleString());
                }
            });
        }
    }

    function initMangfald(section) {
        var mangfald = section.find('.graf-mangfald');
        if (mangfald.length) {
            mangfald.addClass('should-animate');
        }
    }

    function animateGraph(section) {
        var graph = section.find('.graf-stapel');
        if (graph.length && !graph.hasClass('animate')) {
            graph.addClass('animate');
        }
    }

    function animateBelopp(section) {
        var numbers = section.find('.belopp');
        if (numbers.length && !numbers.hasClass('animate')) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                var end = belopp.data('slutbelopp');
                if (start && end && !belopp.hasClass('animate')) {
                    belopp.addClass('animate');
                    animateValue(belopp, start, end, 1200);
                }
            });
        }
    }

    function animateMangfald(section) {
        var mangfald = section.find('.graf-mangfald');
        if (mangfald.length && !mangfald.hasClass('animate')) {
            mangfald.addClass('animate');
        }
    }

    function animateKundnojdhet(section) {
        var graph = section.find('.graf-kundnojdhet');
        var numbers = graph.find('.markor');
        if (graph.length && !graph.hasClass('animate')) {
            graph.addClass('animate');
        }
        if (numbers.length) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                var end = belopp.data('slutbelopp');
                if (start && end && !belopp.hasClass('animate')) {
                    belopp.addClass('animate');
                    animateValue(belopp, start, end, 1000);
                }
            });
        }
    }

    function animateDriftkostnad(section) {
        var graph = section.find('.graf-driftkostnad');
        if (graph.length && !graph.hasClass('animate')) {
            graph.addClass('animate');
        }
    }

    function animateValue(obj, start, end, duration) {
        if (isFloat(end)) {
            obj.prop('Counter', start).animate({
                Counter: end
            }, {
                duration: duration,
                step: function (n) {
                    obj.text(((Math.round(n * 10) / 10).toLocaleString(undefined, {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    })));
                },
                complete: function () {
                    obj.text(hanteraTusental(obj.text()));
                }
            });
        } else if (isInt(end)) {
            obj.prop('Counter', start).animate({
                Counter: end
            }, {
                duration: duration,
                step: function (n) {
                    obj.text(Math.ceil(n)).toLocaleString();
                },
                complete: function () {
                    obj.text(hanteraTusental(obj.text()));
                }
            });
        }
    }

    function isInt(n) {
        return String(n).indexOf('.') < 0;
    }

    function isFloat(n) {
        return String(n).indexOf('.') > -1;
    }

    function hanteraTusental(nr) {
        var str = nr.toString().replace(/\s+/g, '');
        var komma = str.indexOf(',');
        var result = komma < 0 ? str : str.slice(0, komma);

        for (var i = result.length - 3; i > 0; i -= 3) {
            result = result.slice(0, i) + ' ' + result.slice(i);
        }

        if (komma > -1) {
            result += str.slice(komma);
        }
        return result;
    }
});
